import styled from 'styled-components';

export const ProjectsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  overflow: hidden;
  transition: all 0.3s ease-in;
  transition: max-height 0.5s ease-in-out;
  max-width: 320px;
  & > div {
    width: calc(50% - 18px);
    margin-bottom: 18px;
    max-width: 150px;
    &:nth-child(4n) {
      margin-right: 0;
    }
  }
`;

export const ProjectsContainerDesktop = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 660px;
  > div {
    width: 320px;
    height: 320px;

    > button {
      height: 100%;
    }
  }

  .isDesktop {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    align-content: space-between;
    > div {
      width: calc(50% - 9px);
      height: calc(50% - 9px);

      > button {
        height: 100%;
      }
    }
  }
`;

export const WrapperSlider = styled.div`
  & .swiper-container {
    margin: 0 auto;
    position: relative;
    overflow: hidden;
    list-style: none;
    padding: 0;
    z-index: 1;
    width: 100%;
  }
  & .swiper-wrapper {
    display: flex;
  }
  & .swiper-slide {
    flex-shrink: 0;
    width: 100%;
    height: 100%;
    position: relative;
  }
`;

export const RestToProjectsDesktop = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-content: space-between;
  max-width: 320px;
  > div {
    width: 142px;
    height: 142px;
    margin-bottom: 25px;
    > button {
      height: 100%;
    }
  }
  @media (min-width: 1366px) {
    max-width: 660px;
    > div {
      width: 151px;
      height: 151px;
      margin-bottom: 0px;
      margin-top: 15px;
      > button {
        height: 100%;
      }
    }
  }
`;
